module.exports = __webpack_public_path__ + "static/key-molek-2dd15839427375a9109dcca61af0a52e.webp";